<template>
  <div class="initio-formulate-component">
    <component
      :outer-class="hidden[item.name] ? ['initio-formulate--hidden'] : ['']"
      v-on:hide-this-element='$set(hidden, item.name, true)'
      v-bind:is="item.component"
      v-for="item in conditional_elements"
      :key="item.name"
      v-bind="item"
      :validation="item.validation"
      :validation-messages="item.validationMessages"
      >
      <template v-if="item.component != 'FormulateInput' && item.children">
      <span v-html="`${item.children}`"></span>
      </template>
      <initio-formulate
        v-if="item.children && ['FormulateInput','group'].includes(item.component) !== false"
        :elements="item.children"
        :form-answers="formAnswers">
      </initio-formulate>
    </component>
  </div>
</template>

<script>

import { flattenModel } from '@/helpers/answerHelper.js';
import { mapGetters } from 'vuex'

/*
    How the hidden / 'initio-formulate--hidden' hides fields.

    From the custom component, emit this event:   this.$emit('hide-this-element');

    This then listens to the component's events, and if it is set, it marks it as hidden in the hidden object
    The component then adds the hidden class if there hidden[component.name] has been set

 */
export default {
  props: {
    elements: {
      required:true,
      type: Array,
    },
    formAnswers: {
      required:true,
      type: Object,
    },
  },
  data() {
    return {
      hidden: {}
    }
  },
  computed: {
    ...mapGetters(['currentSession']),
    conditional_elements() {

      // let flattenedModel = flattenModel(this.currentSession.answers[this.currentSession.activeStepKey]);
      // Pull the flattened answers, plus the current local answers from the active step via the props 

      // console.log( flattenedModel );
      let flattenedAnswers = this.$store.getters.flattenedAnswers;

      let flattenedModel = new Object;

      for (const [key, value] of Object.entries(flattenedAnswers)) {
        // console.log(value);
        flattenedModel = { ...flattenedModel, ...value };
        //flattenedModel.push({[key]: [value]});
      }
      // console.log( flattenedModel );
      // flattenedModel = Object.keys(flattenedModel).map((k) => flattenedModel[k]);
      // flattenedModel = Object.keys(flattenedModel).map((k) => flattenedModel[k]);

      let conditional_elements = this.elements.filter(c => {
        // Check if it's a conditional field

        if ( c.conditional && c.conditional.length ) {
          for ( let condition of c.conditional ) {
            if ( condition.on && condition.values !== undefined ) {

              if (condition.type == 'match') {
                // if the conditional value is matched, include the field
                if (Array.isArray(condition.values) === true) {
                  for (const value of condition.values) {
                    if (flattenedModel[condition.on] === value) {
                      return c;
                    }
                  }
                }

                if (flattenedModel[condition.on] === condition.values) {
                  return c;
                } else {
                  // else skip including the field
                  return;
                }
              }

              if ( condition.type == 'greater' ) {
                // needs to be greater than
                if (flattenedModel[condition.on] > condition.values) {
                  return c;
                } else {
                  // else skip including the field
                  return;
                }
              }

              return;
            }
          }
        } else {
          // include the field
          return c;
        }
      });

      return conditional_elements;
    }
  },
  name: 'initio-formulate'
}

</script>